export const AutomatedExecutionNoIntervention = '1';
export const AutomatedExecutionInterventionOK = '2';
export const ManualOrder = '3';
